import * as yup from 'yup';

import { BooleanTypeBase } from '../../types/baseTypes/BooleanTypeBase';
import { AllTypeContexts } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_OTHER } from '../constants';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use BooleanType from application-types instead.
 */
export class BooleanType extends BooleanTypeBase {
  group = TYPE_GROUP_OTHER;

  get example() {
    return true;
  }

  get default(): any {
    return false;
  }

  contexts = AllTypeContexts;

  formatter = (value: any) => (value ? 'Yes' : 'No');

  name = 'Boolean';

  friendlyName = 'Yes / No';

  buildSchema() {
    return yup.boolean().nullable();
  }
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Boolean from application-types instead.
 */
const definition = new BooleanType();

Types.addBaseType(definition);

export default definition;
